import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from '../redux/reducerIndex';

const loggerMiddleware = createLogger();

// @ts-ignore
const store = createStore(rootReducer, applyMiddleware(thunk, loggerMiddleware));

export default store;
